import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

/** Ein nummerierter Schritt der manuellen Buchung: Nummer, Titel, Hinweis, Felder, Notiz. */
export function ManualBookingStep({
  n,
  title,
  hint,
  note,
  children,
}: {
  n: number;
  title: string;
  hint?: string;
  note?: string;
  children: ReactNode;
}) {
  return (
    <section aria-labelledby={`manual-step-${n}`} className="flex flex-col gap-2.5">
      <div className="flex items-center gap-2.5">
        <span className="bg-forest-deep rounded-pill flex size-7 flex-none items-center justify-center text-xs font-extrabold text-white">
          {n}
        </span>
        <h3 id={`manual-step-${n}`} className="font-serif text-lg font-bold">
          {title}
        </h3>
        {hint && <span className="text-ink-soft text-xs">{hint}</span>}
      </div>
      {children}
      {note && <p className="text-ink-soft text-xs">{note}</p>}
    </section>
  );
}

/** Feld mit Beschriftung im Rahmen (Board „Manuelle Buchung“); der Rahmen zeigt den Fokus. */
export function ManualField({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <label
      className={cn(
        'border-line rounded-control focus-within:border-forest focus-within:outline-forest flex min-h-[58px] min-w-0 flex-col justify-center gap-0.5 border bg-white px-3.5 py-2 focus-within:outline focus-within:outline-1',
        className,
      )}
    >
      <span className="text-ink-soft text-xs font-semibold">{label}</span>
      {children}
    </label>
  );
}

export const fieldInput =
  'min-w-0 bg-transparent text-[15px] font-bold text-ink outline-none placeholder:font-medium placeholder:text-ink-faint';
